<form nz-form class="form" nzLayout="horizontal" [formGroup]="reportForm">
  <div class="header-with-cta mb-24">
    <h3 class="title s-18">Available options</h3>
  </div>
  <div class="form-grid-secondary mb-24">
    <nz-form-item>
      <nz-form-label nzFor="reportName" nzRequired="true"
        >Report Name</nz-form-label
      >
      <nz-form-control [nzErrorTip]="nameErrorTpl">
        <input
          name="reportName"
          type="text"
          nz-input
          id="reportName"
          formControlName="reportName"
          placeholder="Enter your report name" />
        <ng-template #nameErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            Please enter report name.
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzFor="frequencyInterval"
        >Show Frequency Interval?</nz-form-label
      >
      <nz-form-control nzErrorTip="Please input your title.">
        <nz-select
          nzAllowClear
          nzPlaceHolder="Select"
          id="frequencyInterval"
          name="frequencyInterval"
          (ngModelChange)="onChange()"
          formControlName="showIntervalFrequency">
          <nz-option nzLabel="Yes" [nzValue]="true"></nz-option>
          <nz-option nzLabel="No" [nzValue]="false"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzFor="reportComment"> Report Comment </nz-form-label>
      <nz-form-control>
        <textarea
          id="reportComment"
          name="reportComment"
          rows="6"
          nz-input
          formControlName="comment"
          placeholder="Enter report comment"></textarea>
      </nz-form-control>
    </nz-form-item>
  </div>
  <app-graph-filter
    [graphFilterData]="reportForm.value"
    (filterChange)="onFilterChange($event)"></app-graph-filter>
  <p
    class="error-text mb-24"
    *ngIf="
      reportForm.controls['startDate']?.errors?.['dateInvalid'] ||
      reportForm.controls['endDate']?.errors?.['dateInvalid']
    ">
    Start date cannot be greater than end date.
  </p>

  <nz-table
    #basicTable
    [nzData]="graphList"
    [nzFrontPagination]="false"
    [nzScroll]="{ x: '597px' }">
    <thead>
      <tr>
        <th nzWidth="70px" nzAlign="center">Print</th>
        <th nzWidth="200px">Behavior</th>
        <th nzWidth="200px">Graph Name</th>
        <th nzWidth="200px">Date Range</th>
      </tr>
    </thead>
    <tbody>
      @for (data of basicTable.data; track data) {
        <tr>
          <td nzWidth="70px" nzAlign="center">
            <span
              [nzDisabled]="
                !reportForm.get('startDate')?.value ||
                !reportForm.get('endDate')?.value
              "
              nz-checkbox
              [nzChecked]="isGraphChecked(data)"
              (nzCheckedChange)="onGraphCheckboxChange($event, data)"></span>
          </td>
          <td nzWidth="200px">{{ data.behaviorCategoryName }}</td>
          <td nzWidth="200px">{{ data.unitName }}</td>
          <td nzWidth="200px">
            {{ data.startDataDate | userDate: 'MM/dd/yyyy' }} -
            {{ data.endDataDate | userDate: 'MM/dd/yyyy' }}
          </td>
        </tr>
      }
    </tbody>
  </nz-table>
  <p class="error-text mb-24" *ngIf="checkedGraphList.length === 0">
    Please select at least one graph.
  </p>
</form>
